import { 마켓봄도매소개_Desktop } from "../../components/마켓봄도매_소개_Desktop";
import * as 장치 from "../../components/장치";
import type { GetServerSideProps } from "next";
import { 마켓봄도매소개_Mobile } from "../../components/마켓봄도매_소개_Mobile";
import { loadApplicationPageProps, type ApplicationPageProps } from "../_app";
import { LayoutSplitter } from "../../layouts/LayoutSplitter";

type 마켓봄도매소개Props = {
  장치: 장치.t;
};

const 마켓봄도매소개 = ({ 장치 }: 마켓봄도매소개Props) => {
  return (
    <LayoutSplitter
      장치={장치}
      pc={<마켓봄도매소개_Desktop />}
      mobile={<마켓봄도매소개_Mobile />}
    />
  );
};

export default 마켓봄도매소개;

export const getServerSideProps: GetServerSideProps<
  마켓봄도매소개Props & ApplicationPageProps
> = async (ctx) => {
  const applicationPageProps = await loadApplicationPageProps(ctx);
  return {
    props: {
      장치: 장치.fromContext(ctx),
      ...applicationPageProps,
    },
  };
};
